import Header from "../components/Header";
import Footer from "../components/Footer";

export default function OutsourcingOther() {
  return (
    <>
      <Header />

      {/* ===== HERO SECTION ===== */}
      <section
        className="about-hero"
        style={{
          backgroundImage: "url('/assets/img/OutsourcingOther.jpg')",
        }}
      >
        <div className="overlay"></div>
        <div className="about-hero-text">
          <h1>Outsourcing & Other Services</h1>
          <p>
            Empowering businesses through efficient outsourcing, compliance
            management, and financial excellence.
          </p>
        </div>
      </section>

      {/* ===== Introduction Section ===== */}
      <section className="outsourcing-intro">
        <div className="container">
          <h2>
            Reliable, Efficient & Cost-Effective Business Support Solutions
          </h2>
          <p className="service-text">
            As businesses grow, managing non-core activities like accounting,
            payroll, compliance, and documentation can become time-consuming and
            resource-heavy. Outsourcing these functions to a trusted Chartered
            Accountancy firm ensures accuracy, compliance, and smoother business
            operations — without the overhead cost of hiring full-time
            resources.
          </p>
          <p className="service-text">
            At <strong>S D P M & Co</strong>, we provide comprehensive
            Outsourcing & Business Support Services designed to help
            organisations streamline operations, reduce costs, enhance
            efficiency, and stay compliant. Our services are ideal for startups,
            SMEs, NGOs, corporates, and professionals seeking end-to-end
            administrative and financial assistance.
          </p>
        </div>
      </section>

      {/* ===== Service Cards ===== */}
      <section className="outsourcing-services">
        <div className="container bf-main">
          {/* 1. Accounting & Bookkeeping */}
          <div className="bf-card">
            <h3>📒 Accounting & Bookkeeping Services</h3>
            <p>
              Accurate accounting is the foundation of every successful
              business. We provide fully outsourced bookkeeping services using
              modern software like Tally, Zoho Books, QuickBooks, SAP, and other
              cloud-based systems.
            </p>
            <ul>
              <li> Daily/Monthly bookkeeping</li>
              <li> Accounts payable & receivable management</li>
              <li> General ledger maintenance</li>
              <li> Bank & cash reconciliation</li>
              <li> Expense accounting & MIS reporting</li>
              <li> Fixed asset register management</li>
              <li> Preparation of financial statements</li>
              <li> Month-end & year-end closing assistance</li>
            </ul>
          </div>

          {/* 2. Payroll Processing */}
          <div className="bf-card">
            <h3>💵 Payroll Processing & Compliance</h3>
            <p>
              Payroll involves HR, tax, and statutory compliance. Mistakes can
              lead to employee dissatisfaction and penalties. We offer a fully
              managed payroll outsourcing solution.
            </p>
            <ul>
              <li> Monthly payroll calculation & disbursement</li>
              <li> Leave & attendance integration</li>
              <li> Salary structuring & CTC design</li>
              <li> Preparation of payslips & payroll registers</li>
              <li> TDS on salary computation & filing</li>
              <li> Statutory compliance (PF, ESIC, PT, LWF)</li>
              <li> Employee onboarding/offboarding payroll support</li>
            </ul>
          </div>

          {/* 3. Inventory & Cost */}
          <div className="bf-card">
            <h3>📦 Inventory & Cost Account Review</h3>
            <p>
              Inventory leakage and cost inefficiencies directly affect
              profitability. Our team conducts a systematic review to help
              businesses optimise stock levels and reduce waste.
            </p>
            <ul>
              <li> Inventory verification & valuation</li>
              <li> Cost sheet analysis</li>
              <li> Standard costing & variance analysis</li>
              <li> Stock movement tracking</li>
              <li> Identification of slow-moving & non-moving items</li>
              <li> Internal control review on purchases & warehousing</li>
            </ul>
          </div>

          {/* 4. Trust / Society */}
          <div className="bf-card">
            <h3>🏛️ Trust / Society Registration & Compliance</h3>
            <p>
              Non-profit organisations require expert support to ensure correct
              registration and ongoing compliance.
            </p>
            <ul>
              <li> Trust/Society formation</li>
              <li> Drafting trust deed or bylaws</li>
              <li>
                {" "}
                Registration under The Trusts Act / Societies Registration Act
              </li>
              <li>PAN, TAN & 12A / 80G registration</li>
              <li> Annual compliance, reporting & audit</li>
              <li> FCRA registration / renewal advisory (if applicable)</li>
            </ul>
          </div>

          {/* 5. Startup India */}
          <div className="bf-card">
            <h3>🚀 Startup India & DPIIT Recognition</h3>
            <p>
              Startups must meet specific eligibility norms to obtain government
              recognition and benefits under Startup India.
            </p>
            <ul>
              <li> DPIIT Startup Recognition application</li>
              <li>
                {" "}
                Preparation of required documents & financial projections
              </li>
              <li> Business model validation for eligibility</li>
              <li> Guidance for tax exemptions u/s 80-IAC</li>
              <li> Pitch materials for incubation & funding programs</li>
            </ul>
          </div>

          {/* 6. Digital Signature */}
          <div className="bf-card">
            <h3>🔑 Digital Signature Certificate (DSC) Services</h3>
            <p>
              Digital signatures are mandatory for MCA filings, GST filings,
              income tax filings, tender submissions, and banking procedures.
            </p>
            <ul>
              <li> Class 3 DSC for individuals, directors & companies</li>
              <li> DSC for e-tenders, DGFT, and government portals</li>
              <li> Renewal & re-issuance support</li>
              <li> Aadhaar/PAN-based paperless issuance</li>
              <li> Token & software installation assistance</li>
            </ul>
          </div>
        </div>
      </section>

      {/* ===== Why Choose Us ===== */}
      {/* <section className="nri-highlight">
        <div className="container">
          <h2>Why Outsource With Us?</h2>
          <ul>
            <li>
              Team of experienced Chartered Accountants & Compliance Experts
            </li>
            <li>
              Modern tools & software for accurate and efficient operations
            </li>
            <li>Cost-effective alternative to full-time in-house staff</li>
            <li>
              Timely reporting, transparent processes & absolute confidentiality
            </li>
            <li>
              Tailored outsourcing solutions for startups, SMEs & corporates
            </li>
            <li>Zero penalty, zero delay, 100% compliant execution</li>
          </ul>
          <p className="closing-text">
            From bookkeeping to payroll, NGO compliance to startup registration
            — we take care of the backend so you can focus on growth.
          </p>
        </div>
      </section> */}

      {/* ===== Contact CTA ===== */}
      {/* <section
        className="outsourcing-contact text-center py-5 my-5"
        style={{ background: "linear-gradient(90deg, #00385f, #065a8a)" }}
      >
        <div className="container">
          <h3 className="fw-bold mb-3">Expand Globally With Confidence</h3>
          <p className="mb-4">
            Whether you are an NRI managing assets in India, a business planning
            overseas expansion, or an entity receiving foreign investment — we
            help you stay compliant, tax-efficient, and globally aligned.
            <br />
            Contact <strong>S D P M & Co</strong> today for expert International
            & NRI advisory.
          </p>

          <Link
            to="/contactus"
            className="apply-btn"
            style={{
              backgroundColor: "#65ad4b",
              color: "#fff",
              borderRadius: "8px",
            }}
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          >
            Contact Us
          </Link>
        </div>
      </section> */}

      <Footer />
    </>
  );
}
